import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
export default {
  name: "express-detail",
  props: {
    data: {
      default: function _default() {
        return [];
      }
    },
    type: {
      default: function _default() {
        return 'send';
      }
    },
    canBeSubmit: {
      default: function _default() {
        return false;
      }
    }
  },
  methods: {
    getSendParams: function getSendParams() {
      var params = {};
      var res = this.data.find(function (item) {
        return item._type === 'send';
      });
      if (res) {
        var address = undefined;
        var date = undefined;
        if (res.deserializedInfo && Array.isArray(res.deserializedInfo.data)) {
          var routeData = res.deserializedInfo.data[0];
          address = routeData.location ? routeData.location : undefined;
          date = routeData.time ? routeData.time : undefined;
        }
        params.c02SendRecAddress = address ? address : "".concat(res.originArea).concat(res.originLocation ? "(".concat(res.originLocation, ")") : '');
        params.c02SendRecDate = date ? date : res.originTime;
      }
      return params;
    },
    getBackParams: function getBackParams() {
      var params = {};
      var res = this.data.find(function (item) {
        return item._type === 'back';
      });
      if (res) {
        params.c02BackAddress = "".concat(res.originArea).concat(res.originLocation ? "(".concat(res.originLocation, ")") : '');
        params.c02BackSendDate = res.originTime;
        params.c02BackAddressDistance = res.priciseDistance;
        params.c02BackAddressStatus = res.isWithinLimit ? '正常' : '异常';
        params.c02BackConfirmActualDate = res.acnldgmtTime;
        params.acnldgmtTime = res.acnldgmtTime;
      }
      return params;
    },
    submit: function submit() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var h, params, sendParams, backParams;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              h = _this.$createElement;
              _context.n = 1;
              return _this.$confirm('', {
                title: '确定将快递信息写入函证中?',
                message: h('div', null, [h('p', {
                  style: {
                    'color': '#F56C6C'
                  }
                }, '请注意快递信息中可能存在不规范信息导致数据计算错误，请注意核验数据！'), h('p', null, '如:上海（上海市），地图软件无法正确识别该地址会默认定位至北京')]),
                confirmButtonText: '我已了解'
              });
            case 1:
              params = {};
              sendParams = {};
              backParams = {};
              if (_this.type === 'send') {
                sendParams = _this.getSendParams();
              } else if (_this.type === 'back') {
                backParams = _this.getBackParams();
              } else if (_this.type === 'all') {
                sendParams = _this.getSendParams();
                backParams = _this.getBackParams();
              }
              params = _objectSpread(_objectSpread(_objectSpread({}, params), sendParams), backParams);
              _this.$emit('submit', params);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  }
};